//Component
import AppDispatcher            from '../core/AppDispatcher.jsx';

//Constants
import Constants                from '../constants/BeneficiaryDetailsConstant.js';
import AppConstants             from '../constants/ApplicationConstants.js';
import YourDetailsConstant      from '../constants/YourDetailsConstants.js';

//Utilities
import { EventEmitter }         from 'events';
import Mapper                   from '../utils/Mapper.js';
import Validators               from '../utils/Validators.js';
import  _                       from 'lodash';

//local variables
const CHANGE_EVENT = 'change',
    ActionTypes = Constants.ActionTypes,
    COUNTRY_AUSTRALIA = 'AU';


let _summaryError = [],
    _formError = [];

let _model = _.cloneDeep(Constants.BeneficiaryData);

let _customAttributeName = {
    type: 'Beneficiary type',
    gender: 'Gender',
    title: 'Title',
    givenName: 'Given name',
    lastName: 'Surname',
    relationship: 'Relationship details required',
    dateOfBirth: 'Date of birth',
    postal: 'Postal address',
    postalAddress1: 'Address line 1',
    postalAddress2: 'Address line 2',
    postalCityStatePostCode: 'City/Suburb',
    postalCountry: 'Country',
    postalAusState: 'State',
    postalPostCode: 'Post code',
    mobileNumber: 'mobile number',
    homeNumber: 'home phone number',
    workNumber: 'work phone number',
    emailAddress: 'email address'
};

function getRules(){

    const YdFldRule = YourDetailsConstant.Validations;

    let _fieldRules = {
        type: 'required',
        gender: YdFldRule.personalInfo.gender,
        title: YdFldRule.personalInfo.title,
        givenName: YdFldRule.personalInfo.givenName,
        lastName: YdFldRule.personalInfo.lastName,
        relationship: 'required',
        dateOfBirth: YdFldRule.personalInfo.dateOfBirth,
        postal: YdFldRule.postalAddress.postal,
        postalAddress1: YdFldRule.postalAddress.postalAddress1,
        postalAddress2: YdFldRule.postalAddress.postalAddress2,
        postalCityStatePostCode: YdFldRule.postalAddress.postalCityStatePostCode,
        postalCountry: YdFldRule.postalAddress.postalCountry,
        postalAusState: 'required',
        postalPostCode: 'required|' + YdFldRule.postalAddress.postalPostCode,
        mobileNumber: YdFldRule.contactDetails.mobileNumber,
        homeNumber: YdFldRule.contactDetails.homeNumber,
        workNumber: YdFldRule.contactDetails.workNumber,
        emailAddress: YdFldRule.contactDetails.emailAddress
    };

    if(_model.type === '' || _model.type === Constants.Type.NON_LAPSING){
        delete _fieldRules.gender;
        delete _fieldRules.title;
        delete _fieldRules.givenName;
        delete _fieldRules.lastName;
        delete _fieldRules.relationship;
        delete _fieldRules.dateOfBirth;
        delete _fieldRules.postal;
        delete _fieldRules.postalCountry;
        delete _fieldRules.postalAddress1;
        delete _fieldRules.postalAddress2;
        delete _fieldRules.postalCityStatePostCode;
        delete _fieldRules.postalAusState;
        delete _fieldRules.postalPostCode;
        delete _fieldRules.mobileNumber;
        delete _fieldRules.homeNumber;
        delete _fieldRules.workNumber;
        delete _fieldRules.emailAddress;
    } 

    if(_model.definePostalAddressLine === AppConstants.YesNoValues.NO || _model.definePostalAddressLine===''){
        delete _fieldRules.postalCountry;
        delete _fieldRules.postalAddress1;
        delete _fieldRules.postalAddress2;
        delete _fieldRules.postalCityStatePostCode;
        delete _fieldRules.postalAusState;
        delete _fieldRules.postalPostCode;
    } else if (_model.definePostalAddressLine === AppConstants.YesNoValues.YES) {
        delete _fieldRules.postal;
        if(_model.postalCountry !== COUNTRY_AUSTRALIA){        
            delete _fieldRules.postalAusState;
            delete _fieldRules.postalPostCode;
            _customAttributeName.postalCityStatePostCode = Constants.AddressLabel.CityStatePostCode;
        } else {
            _customAttributeName.postalCityStatePostCode = Constants.AddressLabel.CitySuburb;
        }
    }

    return _fieldRules;
}


function getValidationRules(fieldId) {
    let allRules = getRules(),
        rulesForField = {};

    if (!fieldId) {
        return allRules;
    }

    if (!allRules[fieldId]) {
        return null;
    }

    rulesForField[fieldId] = allRules[fieldId];

    return rulesForField;
}

function clearErrorListForField(componentId) {

    Validators.clearErrorListForField(_formError, componentId);
}

function validateFields(fieldName, fieldValue, componentId) {

    let rules = getValidationRules(fieldName),
        data = {};

    data[fieldName] = fieldValue;

    clearErrorListForField(componentId);

    Validators.validateField(data, rules, _customAttributeName, _formError, fieldName, componentId);
}

function validateAll(){

    _formError = [];
    _summaryError = [];

    if(_model.isNominateBeneficiary === AppConstants.YesNoValues.YES){
        
        const ids = 'bfyD{x}';
        const rules = getRules();
        _formError = Validators.validateAll(_model, rules, _customAttributeName, ids);
        _summaryError = Validators.validateAll(_model, rules, _customAttributeName, ids, Constants.Labels.BENEFICIARY_SECTION);
    }
}

function ResetValues(value){
    if(value === AppConstants.YesNoValues.NO){

        let fields = _.cloneDeep(Constants.FieldNames);

        delete fields.IS_NOMINATED;

        _.forEach(fields, (n) => {
            _model[n] = '';
        });

        _model.resCountry = COUNTRY_AUSTRALIA;

        _formError = [];
        _summaryError = [];
    }
}

function ResetBeneficiaryType(value){
    if(value === Constants.Type.NON_LAPSING){

        let fields = _.cloneDeep(Constants.FieldNames);

        delete fields.IS_NOMINATED;
        delete fields.BENEFICIARY_TYPE;

        _.forEach(fields, (n) => {
            _model[n] = '';
        });

        _model.resCountry = COUNTRY_AUSTRALIA;

        _formError = [];
        _summaryError = [];
    }
}

function updateBeneficiaryModel(fieldId, value, componentId) {
    _model[fieldId] = Mapper.toTrim(value);

    switch (fieldId) {
        case Constants.FieldNames.IS_NOMINATED:
            ResetValues(value);
            break;
        case Constants.FieldNames.BENEFICIARY_TYPE:
            ResetBeneficiaryType(value);
            break;
        default:
            break;
    }

    validateFields(fieldId, value, componentId);

    switch (fieldId) {
    case Constants.FieldNames.MOBILE_NUMBER:
        _model.contactDetails.mobile = Mapper.toTrim(value);
        break;
    case Constants.FieldNames.HOME_NUMBER:
        _model.contactDetails.home = Mapper.toTrim(value);
        break;
    case Constants.FieldNames.WORK_NUMBER:
        _model.contactDetails.work = Mapper.toTrim(value);
        break;
    case Constants.FieldNames.EMAIL_ADD:
        _model.contactDetails.email = Mapper.toTrim(value);
        break;
    default:
        break;
    }
}

function saveBeneficiaryAddress(fieldId, componentId, fieldValue){
    _model[fieldId] = Mapper.toTrim(fieldValue);

    validateFields(fieldId, fieldValue, componentId);
    switch (fieldId) {
    case Constants.FieldNames.DEFINE_ADD_LINE:
        _model.address.address = '';
        break;
    case Constants.FieldNames.POSTAL:
        _model.address.address = Mapper.toTrim(fieldValue);
        _model.address.address1 = '';
        break;
    case Constants.FieldNames.ADDRESS1:
        _model.address.address1 = Mapper.toTrim(fieldValue);
        _model.address.address = '';
        break;
    case Constants.FieldNames.ADDRESS2:
        _model.address.address2 = Mapper.toTrim(fieldValue);
        break;
    case Constants.FieldNames.CITY_STATE_POST:
        _model.address.cityStatePostCode = Mapper.toTrim(fieldValue);
        break;
    case Constants.FieldNames.POSTAL_COUNTRY:
        _model.address.country = Mapper.toTrim(fieldValue);
        break;
    case Constants.FieldNames.AUS_STATE:
        _model.address.australiaState = Mapper.toTrim(fieldValue);
        break;
    case Constants.FieldNames.POST_CODE:
        _model.address.postCode = Mapper.toTrim(fieldValue);
        break;
    default:
        break;
    }
}

function retrieveBeneficiaryModel(data){
    var gender = {};
    if (data.beneficiary && data.beneficiary.isNominateBeneficiary === AppConstants.YesNoValues.YES) {
        _model = _.cloneDeep(data.beneficiary);
        if (_model.gender) {
            gender = _.find(YourDetailsConstant.GenderRadioData, {name: _model.gender});
            if (gender) {
                _model.gender = gender.id;
            }
        }
        mapContactDetails();
        mapAddress();
    } else {
        _model = _.cloneDeep(Constants.BeneficiaryData);
    }
}

function mapContactDetails () {
    if (_model.contactDetails) {
        _model.mobileNumber = _model.contactDetails.mobile || '';
        _model.homeNumber = _model.contactDetails.home || '';
        _model.workNumber = _model.contactDetails.work || '';
        _model.emailAddress = _model.contactDetails.email || '';
    }
}

function mapAddress () {
    if (_model.address) {
        _model.postal = _model.address.address || '';
        _model.postalAddress1 = _model.address.address1 || '';
        if (_model.postalAddress1) {
            _model.definePostalAddressLine = AppConstants.YesNoValues.YES;
        } else {
            _model.definePostalAddressLine = '';
        }
        _model.postalAddress2 = _model.address.address2 || '';
        _model.postalCityStatePostCode = _model.address.cityStatePostCode || '';
        _model.postalCountry = _model.address.country || '';
        _model.postalAusState = _model.address.australiaState || '';
        _model.postalPostCode = _model.address.postCode || '';
    }
}

class BeneficiaryDetailsStoreClass extends EventEmitter {

    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getBeneficiaryModel() {
        return _model;
    }

    getFormError() {
        return _formError;
    }

    getSummaryError() {
        return _summaryError;
    }
}

const BeneficiaryDetailsStore = new BeneficiaryDetailsStoreClass();

BeneficiaryDetailsStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.UPDATE_BENEFICIARY_MODEL:
            updateBeneficiaryModel(action.fieldId, action.value, action.componentId);
            break;
        case ActionTypes.SAVE_BENEFICIARY_ADDRESS:
            saveBeneficiaryAddress(action.fieldId, action.componentId, action.fieldValue);
            break;
        case AppConstants.ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrieveBeneficiaryModel(action.applicationData.form);
            break;
        case AppConstants.ActionTypes.VALIDATE_APPLICATION:
            validateAll();
            break;
        default:
            return true;
    }

    BeneficiaryDetailsStore.emitChange();
    return true;
});

export default BeneficiaryDetailsStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/BeneficiaryDetailsStore.js